import { contragentAvrAPI } from "./api";

export const AVR_STATUS_OPTIONS = [
  { value: "", label: "В работе" },
  { value: "ALL", label: "Все" },
  { value: "CREATED", label: "Создан" },
  { value: "CONTRACTOR_SIGNED", label: "Подписан контрагентом" },
  { value: "SIGNED", label: "Подписан" },
  { value: "DECLINED", label: "Удалён" }
];

export const AVR_TYPE_OPTIONS = [
  { value: "CONTRACTOR_AGREEMENT", label: "Подрядчик" },
  { value: "GENERAL_CONTRACTOR_AGREEMENT", label: "Генподряд" },
  { value: "DESIGN_AGREEMENT", label: "Проектирование" },
  { value: "SUPPORT_AGREEMENT", label: "Сопровождение" },
  { value: "DESIGN_STUIDIO_AGREEMENT", label: "Дизайн-студия" },
  { value: "WITHOUT_AGREEMENT", label: "Без договора" }
];

export const getAvrJournal = async params => {
  try {
    const res = await contragentAvrAPI.getJournal(params);
    return {
      rows: res?.data || [],
      contractors: res?.filter_contractors || []
    };
  } catch (e) {
    return null;
  }
};

export const updateAvrIncomingDocNum = async (contragent_avr_id, incoming_doc_num) => {
  try {
    return await contragentAvrAPI.updateIncomingDocNum(contragent_avr_id, {
      incoming_doc_num
    });
  } catch (e) {
    return null;
  }
};

export const getAvrSignUrl = async (contragent_avr_id, return_url) => {
  try {
    const res = await contragentAvrAPI.sign(contragent_avr_id, { return_url });
    return res?.sign_url || null;
  } catch (e) {
    return null;
  }
};

export const displayAvrNum = row => {
  const num = String(row?.incoming_doc_num ?? "").trim();
  if (!num || num === "без номера") return "—";
  return num;
};

export const canEditAvrNum = row =>
  Number(row?.is_send_to_1c) !== 1 && Number(row?.sign_count || 0) === 0;

export const canSignAvr = row =>
  row?.status_code === "CREATED" &&
  Number(row?.is_send_to_1c) !== 1 &&
  Number(row?.sign_count || 0) < 1;

export const avrSignLine = row => {
  const count = Number(row?.sign_count || 0);
  if (count >= 2) return "ЭЦП: обе стороны";
  if (count === 1) return "ЭЦП: подрядчик";
  return "";
};

export const avrObjectLine = row => {
  const flat =
    row?.flat_num !== null && row?.flat_num !== undefined && row?.flat_num !== ""
      ? `кв. ${row.flat_num}`
      : "";
  return [row?.resident_name, flat].filter(Boolean).join(", ") || "—";
};

export const cleanAvrParams = filters => {
  const params = {};
  Object.entries(filters).forEach(([key, value]) => {
    if (value === "" || value === null || value === undefined) return;
    params[key] = value;
  });
  return params;
};
